'use client'

import { MainHeader } from '../../../shared/ui-kit/actual/headers/MainHeader'

export function ItemDesktopHeaderClient() {
  return <MainHeader />
}
